import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import UVMethod from "@/components/UVMethod";
import LaserTreatments from "@/components/LaserTreatments";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Booking from "@/components/Booking";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminPage from "@/pages/AdminPage";

function Site() {
  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
      <div className="bg-cream font-sans text-ink">
        <div className="grain-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Services />
          <UVMethod />
          <LaserTreatments />
          <Gallery />
          <Reviews />
          <Booking />
        </main>
        <WhatsAppButton />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
